const rootRoute = Object.freeze({
  ARP: 'arp',
  DISCOVERY_STEPS: 'discovery',
  STEPS: 'steps'
})

export { rootRoute }
